import { SystemProps } from "@storyofams/react-ui";

type DynamicSectionProps = {
  first?: boolean;
  content?: any;
  parentComponent?: any;
} & SystemProps;

export const DynamicSection = ({
  content,
  first,
  parentComponent,
}: DynamicSectionProps) => {
  return null;
};
